export default __webpack_public_path__ + "static/media/buttonDown.2162941f.mp3";